import { IcoTimeForward } from '@icons';
import { Tooltip } from 'react-bootstrap';
import React from 'react';
import { Button, OverlayTrigger } from 'react-bootstrap';
import { ConfirmModal, RejectModal, SuccessModal } from '@components/atomic/organisms';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reopenStatements } from '@lib/api_ts/statementsApi';
import { useParams } from 'react-router-dom';

interface ReopenStatementsModalProps {
	id: string;
	isAdv: boolean;
	sentToRegis: boolean;
}

const ReopenStatementsModal: React.FC<ReopenStatementsModalProps> = ({ id, isAdv, sentToRegis }) => {
	const { projectId } = useParams<{ projectId: string }>();
	const [isModalOpen, setIsModalOpen] = React.useState(false);

	const queryClient = useQueryClient();
	const reopenStatementsMutation = useMutation({
		mutationFn: () => reopenStatements(projectId, id),
	});

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	if (isAdv) return null;

	return (
		<>
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip>{sentToRegis ? 'Modifica non disponibile: rendiconto già inviato a ReGiS.' : 'Riapri rendiconto'}</Tooltip>}
			>
				<span>
					<Button variant="link" className="ms-2" onClick={handleOpenModal} disabled={sentToRegis}>
						<IcoTimeForward fill="var(--np-primary-color)" />
					</Button>
				</span>
			</OverlayTrigger>

			<ConfirmModal
				callback={reopenStatementsMutation.mutate}
				confirmButtonLabel="Conferma"
				title="Attenzione"
				show={isModalOpen}
				onHide={handleCloseModal}
				message={
					<span style={{ textAlign: 'left', display: 'block' }}>
						Questo rendiconto potrebbe essere già stato condiviso internamente o inviato a piattaforme esterne. Modificare le numeriche o i
						documenti del rendiconto potrebbe generare disallineamenti.
						<br />
						<br />
						Sei sicuro di voler procedere con la riapertura?
					</span>
				}
			/>
			<SuccessModal
				message="Operazione eseguita con successo. Troverai il rendiconto in Gestione bozze."
				show={reopenStatementsMutation.isSuccess}
				onHide={() => {
					reopenStatementsMutation.reset();
					queryClient.invalidateQueries({ queryKey: ['validatedStatements', projectId] });
					queryClient.invalidateQueries({ queryKey: ['draftStatements', projectId] });
				}}
			/>

			<RejectModal
				message={reopenStatementsMutation.error?.message ?? "Si è verificato un errore durante l'operazione. Riprova più tardi."}
				show={reopenStatementsMutation.isError}
				onHide={reopenStatementsMutation.reset}
			/>
		</>
	);
};

export default ReopenStatementsModal;
